export default ":host .kt-quick-search__category:first-child {\n  margin-top: 0;\n}"